<template>
  <el-dialog
    v-drag
    title="使用ISF模板"
    :visible.sync="dialogVisible"
    width="568px"
    :before-close="cancel"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <BaseTable :height="400" :isPager="false" :tableData="tableData">
      <template slot="opt" slot-scope="row">
        <p style="display: flex;    justify-content: space-around;">
          <el-button type="text" @click="useTpl(row.scope)">使用此模板</el-button>
          <el-button type="text" @click="romoveRow(row.scope)">删除</el-button>
        </p>
      </template>
    </BaseTable>
  </el-dialog>
</template>
<script>
import { getISFTemplate, deleteISFTemplate } from '@/api/bill'
const BaseTable = () => import('@/components/table/BaseTable')
export default {
  components: { BaseTable },
  props: {
    dialogVisible: {
      tyep: Boolean,
      default: false
    },
    isfTpl: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      tableData: {
        fileds: [
          {
            filed: 'name',
            label: '模板名称',
            width: ''
          },
          {
            filed: 'opt',
            width: '180',
            label: '操作',
            isCustom: true
          }
        ],
        columns: []
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getList()
      }
    }
  },
  methods: {
    async getList() {
      try {
        const res = await getISFTemplate()
        if (res.success) {
          this.tableData.columns = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    cancel() {
      this.$emit('cancel')
    },
    useTpl(row) {
        this.$emit('ok', JSON.parse(row.value))
    },
    romoveRow(row) {
      this.$confirm(
        `此操作将删除模板${row.name}, 是否继续?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          closeOnPressEscape: false,
          closeOnClickModal: false,
          center: true
        }
      )
        .then(() => {
            deleteISFTemplate({
                id: row.id
            }).then(res => {
                if (res.success) {
                    this.$message.success('删除成功')
                } else {
                    this.$message.error(res.errorMessage)
                }
            })
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="less" scoped></style>
